import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form/immutable'

import { formatByISO } from 'app/constants/phoneCountryCodes'
import Input from 'app/components/Input'
import { normalizePhoneBeforeInsert } from 'helpers/parsePhone'
import { required } from 'helpers/validators'
import { phoneMinLength, phoneMaxLength } from './index'

const requiredValidation = required('required field')

const InputPhoneNumber = ({ selectedISO, isRequired, ...rest }) => {
  const normalize = (value, previousValue) => normalizePhoneBeforeInsert(selectedISO, value, previousValue)
  const phoneObj = formatByISO[selectedISO]
  const min = phoneMinLength(phoneObj.min)
  const max = phoneMaxLength(phoneObj.max)
  const validate = [min, max]
  if (isRequired) {
    validate.push(requiredValidation)
  }
  return (
    <Field
      name="phone"
      type="tel"
      component={Input}
      normalize={normalize}
      placeholder={phoneObj.format}
      validate={validate}
      {...rest}
    />
  )
}

InputPhoneNumber.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default InputPhoneNumber
